import { ApiService, IJsonObject } from "../api";
import { ProjectTask } from "./";
import { ProjectTaskLabel } from "./ProjectTaskLabel";

/**
 * Functions for fetching project tasks.
 */
export class ProjectTaskService {
	protected apiService: ApiService;

	constructor() {
		this.apiService = new ApiService();
	}

	public async findTasksInStatusForUser(
		status: string,
	): Promise<ProjectTask[]> {
		return this.getTasks("user-by-status", {
			status,
		});
	}

	/**
	 * Finds all tasks due soon current logged in user.
	 */
	public async findTasksDueSoonForUser(): Promise<ProjectTask[]> {
		return this.getTasks("user-due-soon");
	}

	/**
	 * Finds all tasks overdue logged in user.
	 */
	public async findTasksOverdueForUser(): Promise<ProjectTask[]> {
		return this.getTasks("user-overdue");
	}

	/**
	 * Finds all tasks with a start date of today.
	 */
	public async findTasksToStartToday(): Promise<ProjectTask[]> {
		return this.getTasks("user-start-today");
	}

	/**
	 * Finds all tasks being watched by the current user.
	 */
	public async findTasksWatched(): Promise<ProjectTask[]> {
		return this.getTasks("user-watching");
	}

	public async findLabels(): Promise<ProjectTaskLabel[]> {
		const labelData = await this.apiService.get(
			"/api/v1/project-task-labels",
		);

		const labels = await labelData.json();

		return ProjectTaskLabel.fromJsonArray(labels);
	}

	public async toggleWatching(task: ProjectTask): Promise<ProjectTask> {
		const taskData = await this.apiService.post(
			`/api/v1/project/task/${task.id}/toggle-watching`,
		);

		const taskJson = await taskData.json();

		return ProjectTask.fromJson(taskJson);
	}

	private async getTasks(
		endpoint: string,
		params?: IJsonObject,
	): Promise<ProjectTask[]> {
		const taskData = await this.apiService.get(
			`/api/v1/project/tasks/${endpoint}`,
			params,
		);
		const projectTasks = await taskData.json();

		return ProjectTask.fromJsonArray(projectTasks);
	}
}
